$(document).ready(function () {
  let p = $('body').attr('p');

  if (p == 'events') {
    let buffer = '';
    let lastTime = 0;

    // Keystroke-wedge scanners (most common)
    $(document).on('keydown', function (e) {
      const now = Date.now();
      if (now - lastTime > 50) buffer = '';
      lastTime = now;

      if (e.key === 'Enter') {
        if (buffer.length >= 3) onScan(buffer);
        buffer = '';
        return;
      }
      if (e.key.length === 1) buffer += e.key;
    });

    // Paste-mode scanners (fallback)
    $(document).on('paste', function (e) {
      const clipboardData =
        e.originalEvent.clipboardData || window.clipboardData;
      const sku = clipboardData?.getData('text').trim();
      if (sku) onScan(sku);
    });

    function onScan(sku) {
      console.log('Scanned SKU:', sku);
      const productSku = sku.trim();

      $.ajax({
        url: '/api/v1/private/products/get-by-sku',
        method: 'POST',
        data: { sku: productSku, location_id: locationId },
      })
        .done(function (data) {
          if (data.product) {
            console.log('Product found:', data.product);
            //remove any existing fake product button
            $('#sku-scaned-product').remove();

            // Add the product to the cart
            const product = data.product;
            const forceExtra = data.forceProductExtraPopup ? 1 : 0;
            const productId = product.event_ticket_category_id;
            const productName = product.name;
            const priceInclVat = parseFloat(product.price_incl_vat).toFixed(2);
            const priceText = priceInclVat > 0 ? `kr ${priceInclVat}` : '0.00';
            const hasExtra = data.hasProductExtra ? 1 : 0;
            const isOpenPrice = product.is_open_price ? 1 : 0;
            const fakeHTML = `
        <div class="shop-product-container d-none"
             id="sku-scaned-product"
             data-product-name="${productName}"
             data-product-type=""
             data-category-id="all"
             data-force-extra-box="${forceExtra}"
             data-has-product-extra="${hasExtra}"
             style="position: relative;"
             ${isOpenPrice ? 'data-is-open-price="1"' : ''}>

            <button data-product-type=""
                    tabindex="9999"
                    href="#"
                    type="button"
                    class="btn btn-block shop-product alert-primary"
                    id="prod-${productId}-fake with-background-image"
                    data-force-extra-box="${forceExtra}"
                    data-has-product-extra="${hasExtra}"
                    style="background: #cce5ff; border-color: #b8cee6; color: #000000;">

                <p class="product-title"><strong style="font-size: 14px;">${productName}</strong></p>
                <p class="product-price" style="font-size: 14px;">
                    ${priceText}
                </p>
            </button>

            <div class="d-none">
                <div class="col-md-auto product-qty-container-wrapper d-flex">
                    <div class="pull-right product-qty-container">
                        <button id="remove-product-${productId}"
                                class="p-0 btn btn-outline-primary remove-product align-middle product-qty-button "
                                data-product-id="${productId}"
                                data-product-with-category-id=""
                                data-price-incl-vat="${priceInclVat}"
                                data-force-product-extra-popup="${forceExtra}"
                                data-has-product-extra="${hasExtra}"
                                style="cursor: pointer;">
                            <i class="material-icons align-middle p-0">remove</i>
                        </button>

                        <input class="form-control col-6 product-to-order "
                               onfocus="this.select();"
                               data-product-id="${productId}"
                               data-price-incl-vat="${priceInclVat}"
                               value="0"
                               type="number"
                               min="0"
                               id="">

                        <span id="product-price-${productId}"
                              class="text-center pt-2 d-none" style="">kr ${priceText}</span>

                        <button class="p-0 btn btn-primary add-product align-middle product-qty-button "
                                data-product-id="${productId}"
                                data-product-with-category-id=""
                                data-price-incl-vat="${priceInclVat}"
                                data-alter-price-incl-vat="0.00"
                                data-force-product-extra-popup="${forceExtra}"
                                data-has-product-extra="${hasExtra}"
                                style="cursor: pointer;">
                            <i class="material-icons align-middle p-0">add</i>
                        </button>
                    </div>
                </div>
            </div>
        </div>`;

            $('#content').append(fakeHTML);

            // 2. Wait for next frame to make sure it's actually rendered/attached
            requestAnimationFrame(function () {
              const $card = $(`#sku-scaned-product`);
              console.log('Fake product button appended:', $card);
              if ($card.length > 0) {
                $card.find('.shop-product').first().trigger('click');
              }
              return;
            });
          } else if (data.error) {
            const errorMessage = data.message || 'Produkt ikke funnet';
            logger.error('Scan error:', errorMessage);
            showToast({
              type: 'error',
              title: '',
              message: errorMessage,
              position: 'bottom-center',
              duration: 5000,
            });
          }
        })
        .fail(function (data) {
          if (data.responseJSON && data.responseJSON.message) {
            const errorMessage =
              data.responseJSON.message || 'Produkt ikke funnet';
            showToast({
              type: 'error',
              title: '',
              message: errorMessage,
              position: 'bottom-center',
              duration: 5000,
            });
            console.error('Scan error:', data.responseJSON.message);
          } else {
            console.error('Scan error: An unknown error occurred.');
          }
        });
    }
  }
});
